<template>
  <ul class="list-unstyled">
    <li>
      <!--<div class="_help d-flex p-3 px-lg-4 justify-content-between">
        * priset är en uppskattning
        </div>-->

      <div class="_help cursor-pointer mb-3" data-overlay-trigger data-bs-toggle="modal" data-bs-target="#elhandelModal">
        <span class="btn btn-secondary">Hur räknar vi?</span>
        <span class="d-none"><i class="fa-sm far" :class="[overlay ? 'fa-chevron-down' : 'fa-chevron-right']"></i></span>
      </div>

      <transition name="fade">
        <div class="modal fade" id="elhandelModal" tabindex="-1" aria-labelledby="elhandelModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title px-2" id="elhandelModalLabel">Så räknar vi</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <price-details-geab v-if="selectedProduct" :productstring="JSON.stringify(selectedProduct)" :consumption="consumption"></price-details-geab>
                
                 <div class="product-info position-relative p-2" >
             <!-- <div class="product-info-content">
                a
                          href="javascript:void(0)" 
                          @click="overlay = false"
                          class="product-overlay-close btn btn-secondary"  style="top: -1.5em; right: 1em;position: absolute;">
                        <i class="far fa-times fa-fw"></i>
                      </a>   
       

                TODO Aktivera grafen vid tillfälle = plocka bort false nedan
                Timme för Timme-produkten
                <div v-if="false && selectedProduct.priceSource == 5">
                  <div class="col-12 col-md text-center text-md-left my-2 my-md-0" v-show="showChart" style="height: 200px">
                    <ChartSpotprice :timspotprices="selectedProduct.priceDetails.timspotprices" />
                  </div>
                </div>

                Timme för Timme-produkten
                <div v-if="selectedProduct.priceSource == 5 || isIndeXelProduct(selectedProduct)">
                  <div class="d-flex justify-content-between pb-2" :class="{ discount_price: selectedProduct.hasKwhDiscount }">
                    <span>Elpris (medel föregående månad)</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.avg_tim_price) }} öre</span>
                  </div>

                  <div
                    class="d-flex justify-content-between pb-2"
                    v-if="selectedProduct.hasKwhDiscount"
                    :class="{ 'discount-table-price text-danger': selectedProduct.hasKwhDiscount }">
                    <span>Rabatterat pris</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.avg_tim_price) }} öre</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2" v-if="!selectedProduct.isFixedpriceProduct">
                    <span>Elcert</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.certificateprice) }} öre</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span>Påslag</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.pricemarkup) }} öre</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span>Inköpskostnad</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.admincost) }} öre</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span>Moms</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right">{{ selectedProduct.priceDetails.vatPercentage }}%</span>
                  </div>
                  <div class="d-flex justify-content-between pb-4">
                    <span>Fast avgift</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right"
                      ><span v-if="selectedProduct.hasMonthlyDiscount"
                        >{{ selectedProduct.monthlyFeeWithDiscount }}kr/mån i {{ selectedProduct.monthlyFeeDiscountPeriod }} månader
                        därefter</span
                      >
                      {{ selectedProduct.monthlyFee }}kr/mån</span
                    >
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span><strong>Ditt uppskattade elpris</strong></span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <strong class="text-right">{{ selectedProduct.totalPriceWithDiscountVat }} öre/kWh</strong>
                  </div>

                  Beräknade månadskostnaden (Just nu inaktiv)

            <div class="d-flex justify-content-between mt-3">
              <strong>Din beräknade månadskostnad</strong>
              <span class="flex-grow-1 border-bottom m-1"></span>
              <strong class="text-right">{{ selectedProduct.totalMonthlyCostDiscount }} kr</strong>

            </div> 				

           

                  div class="product-overlay-desc mt-3">
            <span v-if="!selectedProduct.isFixedpriceProduct">Elpris och elcert ändras månadsvis. En månads uppsägningstid.<br></span> Jämförpris för elområde {{ selectedProduct.priceDetails.electrictyArea }} (baserat på {{ selectedProduct.priceDetails.comparePriceConsumptionLevel }} kWh): {{ swapDecimalChar(selectedProduct.priceDetails.comparePrice) }} öre/kWh. Elnätsavgifter från ditt elnätsföretag tillkommer.  
            </div
                </div>

                Övriga-produkter
                <div v-if="selectedProduct.priceSource != 5 && !isIndeXelProduct(selectedProduct)">
                  <div class="d-flex justify-content-between pb-2" :class="{ discount_price: selectedProduct.hasKwhDiscount }">
                    <span v-if="selectedProduct.priceSource == 8">Bundet elpris</span>
                    <span v-else>Elpris</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span v-if="!selectedProduct.isFixedpriceProduct" class="text-right"
                      >{{ swapDecimalChar(selectedProduct.priceDetails.price) }} öre</span
                    >
                    <span v-if="selectedProduct.isFixedpriceProduct" class="text-right"
                      >{{ swapDecimalChar(selectedProduct.priceDetails.totalPriceNoDiscount) }} öre</span
                    >
                  </div>

                  <div
                    class="d-flex justify-content-between pb-2"
                    v-if="selectedProduct.hasKwhDiscount"
                    :class="{ 'discount-table-price text-danger': selectedProduct.hasKwhDiscount }">
                    <span>Rabatterat pris</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span v-if="!selectedProduct.isFixedpriceProduct" class="text-right"
                      >{{ swapDecimalChar(selectedProduct.priceDetails.priceDiscount) }} öre</span
                    >
                    <span v-if="selectedProduct.isFixedpriceProduct" class="text-right"
                      >{{ swapDecimalChar(selectedProduct.priceDetails.totalPriceWithDiscount) }} öre</span
                    >
                  </div>
                  <div class="d-flex justify-content-between pb-2" v-if="selectedProduct.priceSource == 8">
                    <span>Profilpris *</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.pricemarkup) }} öre</span>
                  </div>
                  <div class="d-flex justify-content-between pb-2" v-if="!selectedProduct.isFixedpriceProduct">
                    <span>Varav elcert</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span class="text-right">{{ swapDecimalChar(selectedProduct.priceDetails.certificateprice) }} öre</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span>Moms</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span class="text-right">{{ selectedProduct.priceDetails.vatPercentage }}%</span>
                  </div>

                  <div class="d-flex justify-content-between pb-2">
                    <span><strong>Ditt uppskattade elpris</strong></span>
                    <span class="flex-grow-1 border-bottom m-1"></span>
                    <span class="text-right"
                      ><strong>{{ swapDecimalChar(selectedProduct.priceDetails.yourPriceVAT) }} öre/kWh</strong></span
                    >
                  </div>

                  <div class="d-flex justify-content-between pb-4">
                    <span>Fast avgift</span>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <span class="text-right"
                      ><span v-if="selectedProduct.hasMonthlyDiscount"
                        >{{ selectedProduct.monthlyFeeWithDiscount }}kr/mån i {{ selectedProduct.monthlyFeeDiscountPeriod }} månader
                        därefter</span
                      >
                      {{ selectedProduct.monthlyFee }}kr/mån</span
                    >
                  </div>
                  <div class="d-flex justify-content-between pb-2">
                    <strong>Din beräknade månadskostnad</strong>
                    <span class="flex-grow-1 border-bottom m-1"></span>

                    <strong class="text-right">{{
                      swapDecimalChar(((selectedProduct.totalPriceNoDiscountVat * consumption) / 12 / 100 + selectedProduct.monthlyFee * 1).toFixed(0))
                    }} kr</strong>
                  </div>

                  <div class="product-overlay-desc">
                  <span v-if="!selectedProduct.isFixedpriceProduct">Elpris och elcert ändras månadsvis. En månads uppsägningstid.<br></span> Jämförpris för elområde {{ selectedProduct.priceDetails.electrictyArea }} (baserat på {{ selectedProduct.priceDetails.comparePriceConsumptionLevel }} kWh): {{ swapDecimalChar(selectedProduct.priceDetails.comparePrice) }} öre/kWh. Elnätsavgifter från ditt elnätsföretag tillkommer.  
                  </div>

                </div> -->
                  <span><span v-html="getProductTextById(4) "></span>
                  <br />
                  <a v-if="selectedProduct.url" :href="selectedProduct.url" target="_blank">Läs mer</a>

                  <div v-if="selectedProduct.priceSource == 5 || selectedProduct.priceSource == 5" class="d-block mt-3">
                    <div>
                      <div class="d-flex justify-content-between pb-3">
                        <span><i class="far fa-arrow-to-top fa-fw mr-1"></i> Högsta timpris</span>
                        <span class="flex-grow-1 border-bottom m-1"></span>
                        <span>{{ swapDecimalChar(selectedProduct.priceDetails.max_tim_price) }} öre/kWh</span>
                      </div>

                      <div class="d-flex justify-content-between pb-3">
                        <span><i class="far fa-heart-rate fa-fw mr-1"></i> Medel timpris</span>
                        <span class="flex-grow-1 border-bottom m-1"></span>
                        <span>{{ swapDecimalChar(selectedProduct.priceDetails.avg_tim_price) }} öre/kWh</span>
                      </div>

                      <div class="d-flex justify-content-between pb-3">
                        <span><i class="far fa-arrow-to-bottom fa-fw mr-1"></i> Lägsta timpris</span>
                        <span class="flex-grow-1 border-bottom m-1"></span>
                        <span>{{ swapDecimalChar(selectedProduct.priceDetails.min_tim_price) }} öre/kWh</span>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
              </div>
            </div>
          </div>
      </transition>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    swapDecimalChar: { type: Function },
    isIndeXelProduct: { type: Function },
    getProductTextById: { type: Function },
    selectedProduct: { type: Object },
    consumption: { type: Number },
  },
  data() {
    return {
      overlay: false,
      overlayInfo: false,
    };
  },
};
</script>
